import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';
import { immer } from 'zustand/middleware/immer';

import type { ColorSchemeData } from '@nf/types/site';

export interface ColorSchemeStore {
	colorSchemeData: ColorSchemeData;
	setColorSchemeData: (data: ColorSchemeData) => void;
	isLoading: boolean;
	setIsLoading: (isLoading: boolean) => void;
}

export const useColorSchemeStore = createWithEqualityFn<ColorSchemeStore, [['zustand/immer', never]]>(
	immer<ColorSchemeStore>((set, get) => ({
		colorSchemeData: [],
		setColorSchemeData: data => set({ colorSchemeData: data }),
		isLoading: false,
		setIsLoading: isLoading => set({ isLoading })
	})),
	shallow
);